import Typography from "@shared/v2/Typography";
import { TrackingNumber } from "../../types";
import { CheckSolidV6, XmarkLargeSolidV6 } from "@shared/v2/Icomoon";

interface ChangeNumberListProps {
  numbers: TrackingNumber[];
  variant?: "keep" | "delete";
}

const ChangeNumberList: React.FC<ChangeNumberListProps> = ({ numbers, variant = "keep" }) => (
  <div className="tw-bg-white tw-rounded-[8px] tw-flex-1 tw-border-solid tw-border-[1px] tw-border-gray-10 tw-p-[12px] tw-flex tw-flex-col tw-gap-[16px]">
    {/* @ts-expect-error props */}
    <Typography variant="subtitle-m" className="!tw-text-gray-50">
      {variant === "keep" ? "Keep" : "Delete"} these numbers
    </Typography>
    {numbers.map((n) => (
      <div className="tw-flex tw-flex-col tw-gap-[4px]">
        <div className="tw-flex tw-items-center tw-gap-[6px]">
          {/* @ts-expect-error props */}
          <Typography variant="subtitle-m" className={variant === "keep" ? "" : "!tw-text-gray-30"}>
            {n.name}
          </Typography>
          {variant === "keep" ? (
            <CheckSolidV6 className="tw-text-semantic-green-120" />
          ) : (
            <XmarkLargeSolidV6 className="tw-text-semantic-red-120" />
          )}
        </div>
        <div className={variant === "keep" ? "" : "tw-text-gray-30"}>{n.number}</div>
      </div>
    ))}
  </div>
);

export default ChangeNumberList;
